/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const MenuPage = lazyLoad(
  () => import('./index'),
  module => module.MenuPage
);
